var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.indentationLevel},[_c('h4',[_c('span',{staticClass:"label",class:_vm.classes},[_vm._v("\n      "+_vm._s(_vm.parameters.config.text)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }